import $ from "jquery";

function samplePlayer() {
  const $playButton = $(".js-play-sample");
  const $sampleSwitch = $(".js-sample-switch");

  let playing = null;

  function playSample(e) {
    e.preventDefault();
    const sampleSwitch = $(
      `.js-sample-switch[data-lector="${e.currentTarget.dataset.lector}"]`
    );
    if (sampleSwitch) {
      const selectedSample = sampleSwitch.val();
      const $selectedSample = $(
        `.js-sample-player[data-lector="${selectedSample}"`
      );
      if ($selectedSample) {
        if (playing == $selectedSample.get(0)) {
          $selectedSample.get(0).pause();
          playing = null;
          $(this).removeClass("is-playing");
        } else {
          if (playing) {
            playing.pause();
            playing = null;
            $selectedSample.data("playing", false);
            $playButton.removeClass("is-playing");
          }
          playing = $selectedSample.get(0);
          $selectedSample.get(0).volume = 1.0;
          $selectedSample.get(0).play();
          $selectedSample.data("playing", true);
          $(this).addClass("is-playing");
        }
      }
    }
  }

  function switchSample(e) {}
  $sampleSwitch.change(switchSample);
  $playButton.click(playSample);
}
samplePlayer();
